import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import Brand_Icon from '../../Assets/Images/BrainbitsLogoOnly.jpg'
import Brand_Icon_2 from '../../Assets/Images/BrainbitsLogoOnly.jpg'

const Navigation = () => {

    const [mobile, setMobileNav] = useState(false)
    const mobileNav = () => {
        setMobileNav(true)
    }
    const closeNav = () => {
        setMobileNav(false)
    }

    const [sticky, setSticky] = useState(false);

    useEffect(()=>{
        window.addEventListener('scroll', ()=>{
            window.scrollY > 50 ? setSticky(true) : setSticky(false)
        })
    },[])

  return (
    <div className={`${sticky ? 'md:bg-white' : 'md:bg-white'} transform transition-transform duration-300 ease-in-out w-full bg-white relative`}>
        <div className='mx-auto max-w-6xl px-2 md:px-4 xl:px-8 py-1 flex items-center justify-between'>
            <div className='text-xl font-black text-blue-900 md:text-white flex items-center gap-1'>
                <Link to='/'>
                <img src={Brand_Icon} alt='Brand Icon' className='w-16 hidden md:block'/>
                </Link>
                <Link to='/'>
                <img src={Brand_Icon_2} alt='Brand Icon' className='w-16 md:hidden block'/>
                </Link>
                </div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={mobile ? "rotate-90 size-6":"size-6 text-blue-900 md:hidden transform transition-transform duration-300 rotate-0"} onClick={mobileNav}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25" />
            </svg>

            <ul className={mobile ? 'block absolute w-3/4 bg-blue-900 right-0 top-0 bottom-0 z-10 min-h-screen opacity-90' : 'hidden md:flex gap-2 items-center transition-transform duration-300 ease-in-out transform'}>
            <div className='block md:hidden flex items-center justify-between p-2'>
                <div className='text-xl font-black text-white flex items-center gap-1'>
                    <Link to='/'>
                    <img src={Brand_Icon} alt='Brand Icon' className='w-16'/>
                    </Link>
                    </div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-white" onClick={closeNav}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
            </div>
            <li className={mobile ? 'p-2':'px-3 text-sm'}>
            <NavLink
                to="/"
                className={({ isActive }) =>
                isActive ? 'md:text-blue-900 text-white font-bold' : 'md:text-blue-700 text-white'
                }
            >
                Home
            </NavLink>
            </li>
            <li className={mobile ? 'p-2':'px-3 text-sm'}>
            <NavLink
                to="/about"
                className={({ isActive }) =>
                isActive ? 'md:text-blue-900 text-white font-bold' : 'md:text-blue-700 text-white'
                }
            >
                About Us
            </NavLink>
            </li>
            <li className={mobile ? 'p-2':'px-3 text-sm'}>
            <NavLink
                to="/solutions"
                className={({ isActive }) =>
                isActive ? 'md:text-blue-900 text-white font-bold' : 'md:text-blue-700 text-white'
                }
            >
                Services
            </NavLink>
            </li>
            <li className={mobile ? 'p-2':'px-3 text-sm'}>
            <NavLink
                to="/contact"
                className={({ isActive }) =>
                isActive ? 'md:text-blue-900 text-white font-bold' : 'md:text-blue-700 text-white'
                }
            >
                Contact
            </NavLink>
            </li>
            </ul>
        </div>
    </div>
  )
}

export default Navigation